/** How long a toast stays up, unless the caller passes an explicit `timeout`. */
export const DEFAULT_TIMEOUT = 5000

/** Minimum wall-clock gap between two consecutive toasts being revealed. */
export const REVEAL_GAP_MS = 500

export const ENTER_DURATION_MS = 200
export const EXIT_DURATION_MS = 160

export const TOAST_CARD_WIDTH = 380
export const TOAST_CARD_MAX_WIDTH = 420

// Mirrors LAYOUT.bottomTabHeight (@mobile/modules/dashboard/screens/home/tokens).
// Kept local so common/ never imports from @mobile/ — same technique as
// web/modules/settings/contexts/SettingsRoutesContext/styles.ts.
export const BOTTOM_TAB_BAR_HEIGHT = 64
